<div class="dropdown-section sm:pb-0 pb-3 w-[366px]" [class]="dropdownAlignment">
  <p class="dropdown-label font-extrabold">{{dropdownTopLabel}}</p>
  <div class="dropdown inline-block relative text-center hidden sm:block">
    <button
      class="dropdown-button w-full relative leading-6 flex justify-between"
      (keyup.enter)="dropdownCollapse = !dropdownCollapse"
      (click)="toggleDropdown()"
      >
            <span class="mr-2 dropdown-text truncate
            ">{{ dropdownPlaceholder }}</span>
      <div class="dropdown-items">
        <span class="dropdown-item-line"></span>
        <fa-icon [icon]="faCaretDown" class="fa-xs dropdown-icon dropdown-caret"> </fa-icon>
      </div>
    </button>
    <div class="h-2"></div>
    <ul
      class="dropdown-menu dropdown-section absolute text-left overflow-y-auto bg-white rounded-md  w-[366px] shadow-sm drop-shadow-sm z-50 w-full"
      [ngClass]="{ hidden: !dropdownCollapse, block: dropdownCollapse }"
      >
      @for (d of dropdownItems; track d) {
        <!-- If no link, set item as a section header -->
        @if (!d.dropdownLink && !d.dropdownValue) {
          <li class="dropdown-item-header block pt-4 px-6 pb-1">
            @if (!d.dropdownLink) {
              <label class="eyebrow">
                {{ d.dropdownLabel }}
              </label>
            }
          </li>
        }
        <!-- If dropdown value is present render a button instead of a link -->
        @if (d.dropdownValue) {
          <li>
            <!-- handleChange acts as a function to simulate the onChange ev from a select element -->
            <button (click)="handleChange(d.dropdownValue)" class="dropdown-item text-left py-3 px-6 w-full">
              {{ d.dropdownLabel }}
            </button>
          </li>
        }
        <!-- If link, set item as a clickable link -->
        @if (d.dropdownLink) {
          <li class="dropdown-item">
            <a
              class="block py-3 px-6"
              href="{{ d.dropdownLink }}"
              [attr.aria-labelledby]="getIdToAriaLabelledbyContext(d.dropdownLabel)"
              [attr.target]="d.dropdownLinkNewTab ? '_blank' : ''"
              [attr.data-formelementid]="d.dropdownCtaTag ? d.dropdownCtaTag : null"
                    [attr.rel]="
                    d.dropdownLinkNewTab && d.dropdownLinkNofollow
                        ? 'nofollow noopener noreferrer'
                        : d.dropdownLinkNewTab && !d.dropdownLinkNofollow
                        ? 'noopener noreferrer'
                        : d.dropdownLinkNofollow
                        ? 'nofollow'
                        : ''
                    "
              >
              <span>{{ d.dropdownLabel }}</span>
              <!-- Hidden Context -->
              <span [attr.id]="accessibilityService.getAriaLabelledby(d.dropdownLabel) + '-context'" class="sr-only">{{getTextContext(d.dropdownLink)}}</span>
            </a>
            @if (!d.dropdownLink) {
              <label class="text-vis-regular">
                {{ d.dropdownLabel }}
              </label>
            }
          </li>
        }
      }
    </ul>
  </div>
  <select [attr.aria-label]="dropdownTopLabel ?? 'Select an option'"
    (change)="!dropdownItems[0].dropdownValue ? onChange($event) : handleChange($event)" id="mobile_select"
    class="sm:hidden xs:inline-flex relative truncate w-full">
    <option selected disabled [value]="dropdownPlaceholder">{{ dropdownPlaceholder }}</option>
    @for (d of dropdownItems; track d) {
      <option value="{{ !d.dropdownValue ? d.dropdownLink : d.dropdownValue }}"
        [class.new-tab]="d.dropdownLinkNewTab" [disabled]="!d.dropdownLink && !d.dropdownValue">
        {{ d.dropdownLabel }}
      </option>
    }
  </select>
</div>
